import { useSupabaseAuth } from '../lib/useSupabaseAuth'

const TokenErrorHandler = () => {
  const { tokenError, authError } = useSupabaseAuth()

  // Only show error handler for critical token errors, not temporary auth issues
  if (!tokenError) return null

  const handleClearAndReload = () => {
    // Clear all auth data
    localStorage.clear()
    sessionStorage.clear()
    
    // Reload the page
    window.location.reload()
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md mx-4 shadow-xl">
        <div className="flex items-center mb-4">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-primary">Authentication Error</h3>
            <p className="text-sm text-secondary">Your session has expired or become invalid</p>
          </div>
        </div>
        
        <div className="mb-4">
          <p className="text-sm text-secondary mb-2">
            This usually happens when:
          </p>
          <ul className="text-sm text-secondary list-disc list-inside space-y-1">
            <li>Your session has expired</li>
            <li>You&apos;ve been signed out from another device</li>
            <li>There was a server-side authentication change</li>
          </ul>
        </div>

        {authError && (
          <div className="mb-4 p-3 bg-gray-100 rounded text-xs text-secondary font-mono">
            {authError.message || 'Unknown authentication error'}
          </div>
        )}

        <div className="flex space-x-3">
          <button
            onClick={handleClearAndReload}
            className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
          >
            Clear & Reload
          </button>
          <button
            onClick={() => window.location.href = '/login'}
            className="flex-1 bg-gray-200 text-primary px-4 py-2 rounded-md hover:bg-gray-300 transition-colors"
          >
            Go to Login
          </button>
        </div>
      </div>
    </div>
  )
}

export default TokenErrorHandler